<template>
    <div class="nav">
        <p class="bookNum">本馆图书：{{ bookNum }}</p>
        <div>
            <router-link to="/" class="logo">
                <img src="@/assets/logo.png"  />
            </router-link>
            <nav>
                <router-link to="/">首页</router-link>
                <router-link to="/main">阅读空间</router-link>
                <!-- <router-link to="/news">新书动态</router-link> -->
                <router-link to="/about">联系我们</router-link>
                <router-link to="/user">个人中心</router-link>
            </nav>  
        </div>
        <div class="btn-part">
            <!-- <button class="m-button" v-if="!isLogin" @click="goToLogin">登录</button> -->
            <LoadingButton class="m-button" v-if="!isLogin" :buttonText="'登录'"  @button-click="goToLogin" :loading="loading"></LoadingButton>

            <div v-show="isLogin">欢迎 {{ username }}</div>
            <!-- <button class="m-button" v-if="isLogin" @click="logout">登出</button> -->
            <LoadingButton v-if="isLogin" :buttonText="'登出'"  @button-click="logout"></LoadingButton>
            <!-- <button @click="logout()" class="m-button">注册</button> -->
        </div>
        <!-- 底部nav -->
        <div class="btm-nav">
            <nav>
                <router-link to="/">
                    <i v-show="!isActive('/')" class="iconfont icon-a-icon_home_"></i>
                    <i v-show="isActive('/')" class="iconfont icon-a-icon_home_-1"></i>
                    <p>首页</p>
                </router-link>
                <router-link to="/main">
                    <i v-show="!isActive('/main')" class="iconfont icon-a-Component1"></i>
                    <i v-show="isActive('/main')" class="iconfont icon-a-Component2"></i>
                    <p>书间</p>
                </router-link>
                <!-- <router-link to="/news">
                    <i v-show="!isActive('/news')"  class="iconfont icon-a-Component4"></i>
                    <i v-show="isActive('/news')"  class="iconfont icon-a-Component3"></i>
                    <p>新闻</p>
                </router-link> -->
                <router-link to="/about">
                    <i v-show="!isActive('/about')" class="iconfont icon-a-Frame427318957"></i>
                    <i v-show="isActive('/about')" class="iconfont icon-a-Frame427318958"></i>
                    <p>我们</p>
                </router-link>
                <router-link to="/user">
                    <i v-show="!isActive('/user')" class="iconfont icon-a-Vector5"></i>
                    <i v-show="isActive('/user')" class="iconfont icon-a-Vector6"></i>
                    <p>我</p>
                </router-link>
            </nav>  
        </div>
    </div>
</template>

<script>
import { logout, getUser } from '@/_api/login'
import { getBookSum } from '@/_api/book'
import { mapGetters } from 'vuex';

export default ({
    name: "Nav",
    data() {
        return{
            username: '',
            isLogin: false,
            loading: false,
            bookNum: 0
        }
    },
    computed: {} ,
    mounted() {
        this.getAuthorizeSetting()
        this.getBookSum()
    },
    methods: {
        getBookSum() {
            getBookSum().then((res) => {
                if (res.status == 'ok') {
                    this.bookNum = res.data.bookNum || 0
                }
            })
        },
        logout() {
            this.$store.dispatch('user/updateUserInfo', {
                userId: undefined,
                username: undefined,
                avatar: undefined,
            });
            logout().then((res) => {
                if (res.code == 1004) {
                    this.$router.push('/login')
                }
            })
        },
        getAuthorizeSetting() {
            this.loading = true
            const token = localStorage.getItem('token');
            const username = this.$store.state.user.username
            console.log(token, username)
            if (token && username) {
                this.username = username
                this.isLogin = true
            }
            else if (token) {
                getUser().then((res) => {
                    if(res.status == 'ok') {
                        this.username = res.username
                        this.isLogin = true
                    } else {
                        this.isLogin = false
                    }
              
                })
            }
            this.loading = false
        },
        goToHome() {
            this.$router.push("/")
        },
        isActive(route) {
            // 判断当前路由是否匹配指定的路由
            return this.$route.path === route;
        },
        goToLogin() {
            if (this.loading) return
            this.$router.push("/login")
        }
    }
})
</script>

<style lang="less">
.nav {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 27px 100px 27px 35px;
    height: 112px;
    background: #FFFFFF;
    color: var(--text-color);
    width: 100vw;
    z-index: 999;
    .btn-part {
        display: flex;
        align-items: center;
        span {
            // color: #000000;
            font-weight: 600;
            font-size: 14px;
        }
        button {
            font-size: 14px;
            letter-spacing: 5px;
        }
    }
    img {
        cursor: pointer;
        width: 70px;
    }
    .mb {
        display: none;
    }
    nav {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    nav a {
        color: var(--head-line);
        text-decoration: none;
        margin: 0 15px;
        font-size: 16px;
    }
    div {
        display: flex;
        gap: 30px;
        button {
            background: var(--head-line);
            color: #FFFFFF;
        }
    }
    .btm-nav {
        padding: 30px 0 30px 0;
        width: 100vw;
        bottom: 0;
        left: 0;
        position: fixed;
        background: #E2E2E2;
        border-radius: 25px 25px 0 0;
        display: none;
        @media screen and (max-width:650px) {
            display: block;
        }
        nav {
            width: 100%;
            display: flex;
            justify-content: space-evenly;
            .iconfont {
                font-size: 18px;
            }
        }
        p {
            margin-top: 5px;
            color: #000000;
            font-size: 12px;
        }
    }
    @media screen and (max-width:1050px) {
        padding: 27px 35px 27px 35px;
        height: 90px;
        nav a{
            font-size: 12px;
            margin: 0 8px;
        }
        div {
            display: flex;
            gap: 10px;
            button {
                font-size: 13px;
                height: 27px;
                width: 80px;
            }
        }
    }
    @media screen and (max-width:520px) {
        padding: 20px 15px 20px 15px;
        height: 80px;
    }   
    @media screen and (max-width:650px) {
        nav {
            display: none;
        }
    }
}

.bookNum {
    color:red;
    font-size:12px;
    position: absolute;
    right: 20px;
    top: 5px;
}
.logo img {
    width: 148px;
}
</style>
